// extracted by mini-css-extract-plugin
export default {"radio-group":"radio-group_radio-group__dsZ8n","label":"radio-group_label__flguw"};